import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { EventAvailable } from '@material-ui/icons';
import { Col, Container, Row, Button } from 'reactstrap';
import { useHistory } from "react-router-dom";

import AlertModal from '../../../../shared/components/Modal';

const UpdateVisitsModal = ({
    visit,
    opened,
    CloseUpdateVisitModal,
    maxNum,
    feasibility
}) => {

    const history = useHistory();

    //Visita
    const [nameVisit, setNameVisit] = React.useState(null);
    const [numberVisit, setNumberVisit] = React.useState(null);

    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");
    const [openModal, setOpenModal] = React.useState(opened);


    const [visitChanges, setVisitChanges] = React.useState(null);


    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const confirmChangeVisits = () => {
        setAlertColorModal("warning");
        setAlerShowModal(true);
        setAlertMessageModal("Esta Seguro que desea realizar los cambios??");
    }

    const okModal = () => {
        switch (colorAlertModal) {
            case "warning":
                submitChangesVisit(visitChanges);
                break;

            case "success":
                let _url = "/clinical-studio/budget";
                if (window.location.pathname === process.env.PUBLIC_URL + '/clinical-studio/budget') {
                    history.replace(process.env.PUBLIC_URL+"/");
                    setTimeout(() => {
                        history.replace({
                            pathname: process.env.PUBLIC_URL +_url,
                            state: feasibility
                        });
                    }, 0);
                } else {
                    history.push({
                        pathname: process.env.PUBLIC_URL +_url,
                        state: feasibility
                    });
                }
                break;
            default:
                setNameVisit(null);
                setNumberVisit(null);
                setAlerShowModal(false);
                break;
        }
    }

    const closeModal = () => {

        console.log("WTF");
        setNameVisit(null);
        setNumberVisit(null);
        setOpenModal(false);
        CloseUpdateVisitModal(false)
    }

    const confirmChangeVisit = (avisado) => {
        let visitaModificada =
        {
            id_visita: visit != null ? visit.id_visita : null,
            nombre: null,
            num_visita: null,
            id_factibilidad: visit != null ? visit.id_factibilidad : null,
            old_num_visita: visit != null ? visit.num_visita : null,
        }

        //Validaciones
        if (nameVisit == null && (visit.nombre == null || visit.nombre == undefined)) {
            alert("Ingrese el Nombre");
            return false;
        }
        else {
            visitaModificada.nombre = nameVisit != null ? nameVisit : visit.nombre;
        }

        if (numberVisit == null && (visit.num_visita == null || visit.num_visita == undefined) || visit.num_visita == 0) {
            alert("Ingrese el número de visita");
            return false;
        }
        else {
            visitaModificada.num_visita = numberVisit != null ? parseFloat(numberVisit) : visit.num_visita;
        }

        setVisitChanges(visitaModificada);
        confirmChangeVisits(visitaModificada);

    }

    const submitChangesVisit = async (visitModify) => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}visitas/update`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(visitModify)
        }).then(response => response.json()).then(data => {
            alertModal(true, "Visita actualizada correctamente");
        }).catch(err => {
            alertModal(false, "Ha ocurrido un error en el servidor");
            console.log(err);
        });
    }


    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000, width: '100%' }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>

                    <div>
                        <div>
                            <h5 className="bold-text">Editar Visita
                                {visit != null ? visit.num_visita + " " : " "}
                                ({visit != null ? visit.nombre : ""})</h5>

                            <Row>
                                <Col md={6}>
                                    <TextField
                                        defaultValue={visit != null ? visit.nombre : ""}
                                        onChange={(event) => setNameVisit(event.target.value)}
                                        style={{ minWidth: '300px', maxWidth: '300px' }}
                                        label="Nombre de la Visita"
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                        value={nameVisit}
                                    />
                                </Col>

                                <Col md={6}>
                                    <TextField
                                        defaultValue={visit != null ? visit.num_visita : null}
                                        onChange={(event) => {
                                            if (maxNum < parseFloat(event.target.value)) {
                                                setNumberVisit(numberVisit);
                                            }
                                            else {
                                                setNumberVisit(event.target.value);
                                            }
                                        }

                                        }
                                        style={{ minWidth: '300px', maxWidth: '300px' }}
                                        label="Número de la Visita"
                                        type="number"
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                        value={numberVisit}
                                    />
                                </Col>
                            </Row>

                            <Button
                                disabled={false}
                                style={{ marginTop: 10, marginRight: 10 }}
                                variant="contained"
                                className="btn btn-primary btn-sm text-white"
                                onClick={() => {
                                    confirmChangeVisit();
                                }}
                            >
                                Confirmar
                            </Button>
                            <Button
                                style={{ marginTop: 10 }}
                                variant="contained"
                                className="btn btn-secondary btn-sm"
                                onClick={() => {
                                    closeModal();
                                }}
                            >
                                Cerrar
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => okModal()}
                toggle={() => {

                    if (colorAlertModal != "success") {
                        setVisitChanges(null)
                        setAlerShowModal(false)
                    }
                    else {
                        let _url = "/clinical-studio/budget";
                        if (window.location.pathname === process.env.PUBLIC_URL + '/clinical-studio/budget') {
                            history.replace(process.env.PUBLIC_URL+"/");
                            setTimeout(() => {
                                history.replace({
                                    pathname:process.env.PUBLIC_URL + _url,
                                    state: feasibility
                                });
                            }, 0);
                        } else {
                            history.push({
                                pathname: process.env.PUBLIC_URL +_url,
                                state: feasibility
                            });
                        }
                    }

                }
                }
            />
        </div>
    );
};
export default UpdateVisitsModal;
